import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation("global");

  return (
    <div className="bg-white">
      <section
        id="us"
        className="w-full min-h-screen flex flex-col md:flex-row items-stretch"
      >
        <div className="w-full md:w-1/2 order-2 md:order-1 flex flex-col flex-grow md:flex-grow-0 min-h-[300px] md:min-h-0">
          <img
            src={
              new URL(
                "../../assets/images/avion-last-section.png",
                import.meta.url
              ).href
            }
            alt="avion-last-section"
            className="w-full h-full object-cover block"
          />
        </div>
        <div className="w-full md:w-1/2 order-1 md:order-2 px-6 md:px-12 py-12 md:py-20 flex items-center">
          <div className="text-left w-full">
            <h3
              data-translate="US"
              className="text-3xl font-semibold pt-4 md:pt-0"
            >
              {t("US.text")}
            </h3>
            <h4 className="text-lg md:text-xl pt-4">
              <span className="text-[#fcab22] font-bold">Fly Xom </span>
              {t("US2.text")}
            </h4>
            <p className="text-sm md:text-base pb-4">{t("US3.text")}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
